import { anyFunction } from "@dhx/ts-common/types";

export interface ICalendarConfig{
	value?: Date | Date[] | string | string[];
	date?: Date | string;
	css?: string;
	mark?: (a:Date) => string; // custom css for day cell
	block?: (a:Date) => boolean;  // disabeled dates
	weekStart?: "monday" | "sunday";
	weekNumbers?: boolean;
	view?: ViewMode;
	timePicker?: boolean;
	dateFormat?: string;
	timeFormat?: 24 | 12;
	thisMonthOnly?: boolean;
	width?: string;
	range?: boolean;
	$rangeMark?: (a:Date) => string;
}

export interface ICalendar {
	setValue(value: Date | Date[] | string | string[]): boolean;
	getValue(asDatObj?: boolean): Date | Date[] | string | string[];
	showDate(date?: Date, mode?: ViewMode): void;
	link(calendar: ICalendar): void;
	destructor(): void;
	getCurrentMode(): ViewMode;
	paint(): void;
}

export enum ViewMode {
	calendar = "calendar",
	years = "year",
	months = "month",
	timepicker = "timepicker"
}

export interface ICalendarDay {
	css: string;
	date: Date;
	day: number;
}
export interface ICalendarWeek {
	weekNumber: number;
	days: ICalendarDay[];
	disabledWeekNumber?: boolean;
}

export enum CalendarEvents {
	change = "change",
	beforeChange = "beforechange",
	modeChange = "modeChange",
	dateHover = "dateHover",
	monthSelected = "monthSelected",
	yearSelected = "yearSelected",
	cancelClick = "cancelClick"
}

export interface ICalendarHandlersMap {
	[key: string]: (...args: any[]) => any;
	[CalendarEvents.change]: (date: Date, oldDate: Date, byClick: boolean) => any;
	[CalendarEvents.beforeChange]: (date: Date, oldDate: Date, byClick: boolean) => boolean | void;
	[CalendarEvents.dateHover]: (date: Date, e: MouseEvent) => any;
	[CalendarEvents.modeChange]: (mode: string) => any;
	[CalendarEvents.monthSelected]: (month: number) => any;
	[CalendarEvents.yearSelected]: (year: number) => any;
	[CalendarEvents.cancelClick]: () => any;
}